import { DeleteOutlined, DownloadOutlined, EditOutlined, EyeOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Modal, Popconfirm, Row, Select, Table, Tabs, Tooltip } from "antd";
import * as FileSaver from "file-saver";
import { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { deleteManager } from "redux/actions/deleteManager.action";
import { getGroupInfo } from "redux/actions/getGroup.action";
import { getManagementData } from "redux/actions/management.action";
import { postNewManager } from "redux/actions/postNewManager.action";
import { getStateList } from "redux/actions/stateList.action";
import { updateManager } from "redux/actions/updateManager.action";
import * as XLSX from "xlsx";
import { getApiArrayDetails, handleTableSort, isValidArray, spaceValidation } from "../../../utils/MyMUtils";
import generatePDFManagement from "./generatePdfManagement";
import { PASSWORD_HINT, PASSWORD_MAX, confirmPasswordRules, passwordRules } from "utils/passwordRules";

const { Option } = Select;
const { TabPane } = Tabs;

const ManagementContact = () => {
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
  const [visibleModal, setVisibleModal] = useState(false);
  const [defaultValue, setDefaultValue] = useState("");
  const [getState, setGetState] = useState("");
  const [userID, setUserID] = useState("");
  const [displayModal, setDisplayModal] = useState(false);
  const [stateID, setStateID] = useState("");
  console.log("🚀 ~ ManagementContact ~ stateID:", stateID)
  const [fileName, setFileName] = useState("Management Details");

  const organizationList = useSelector((state) => getApiArrayDetails(state.getGroupInfo.data));
  console.log("🚀 ~ ManagementContact ~ organizationList:", organizationList);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGroupInfo());
  }, []);

  useEffect(() => {
    form.resetFields();
  }, [visibleModal]);

  useEffect(() => {
    form2.resetFields();
  }, [visible]);

  useEffect(() => {
    form3.resetFields();
  }, [displayModal]);

  const contractorList = useSelector((state) => getApiArrayDetails(state.management.data));

  const stateList = useSelector((state) => getApiArrayDetails(state.stateList.data));

  useEffect(() => {
    dispatch(getManagementData());
  }, []);

  useEffect(() => {
    dispatch(getStateList());
  }, []);

  const postNewManagerRecord = useSelector((state) => {
    return state.postNewManagerInfo.data;
  });

  const updateManagerRecord = useSelector((state) => {
    return state.updateManagerInfo.data;
  });

  const deleteManagerInfo = useSelector((state) => {
    return state.deleteManager.data;
  });

  const exportToCSV = (csvData, fileName) => {
    if (csvData) {
      const ws = XLSX.utils.json_to_sheet(csvData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } else {
      toast.error("There is no data to export.");
    }
  };

  const excelData = () => {
    if (isValidArray(contractorList)) {
      return contractorList?.map((item) => {
        return {
          "First Name": item.first_name,
          "Last Name": item.last_name,
          "Job Title": item.job_title,
          "Phone Number": item.mobile,
          Email: item.email,
          Address: item.address,
          State: item.state,
        };
      });
    }
  };

  const updateModalFunction = (elm) => {
    setDefaultValue(elm);
    setVisibleModal(true);
    setUserID(elm.user_id);
    setGetState(elm.state_id);
  };

  const postNewManagerFunction = (data) => {
    dispatch(postNewManager(data)).then((record) => {
      if (record.payload.success === true) {
        toast.success(record.payload.message);
        dispatch(getManagementData());
        setStateID("");
      } else {
        setStateID("");
        toast.error(record.payload.message);
        dispatch(getManagementData());
      }
    });
    setVisible(false);
  };

  const updateManagerFunction = (info) => {
    const updateInfo = {
      ...info,
      state_id: getState,
      user_id: userID,
    };
    dispatch(updateManager(updateInfo)).then((record) => {
      if (record.payload.success === true) {
        toast.success(record.payload.message);
        dispatch(getManagementData());
      } else {
        toast.error(record.payload.message);
        dispatch(getManagementData());
      }
    });
    setVisibleModal(false);
  };

  const deleteFunction = (elm) => {
    dispatch(deleteManager(elm.user_id)).then((record) => {
      if (record.payload.success === true) {
        toast.success(record.payload.message);
        dispatch(getManagementData());
      } else {
        toast.error(record.payload.message);
        dispatch(getManagementData());
      }
    });
  };

  const ViewFunction = (elm) => {
    setDisplayModal(true);
    setDefaultValue(elm);
  };

  const handleStateChange = (value) => {
    setStateID(value);
  };

  const getStateListDetails = () => {
    if (isValidArray(stateList)) {
      return stateList.map((state) => {
        if (organizationList?.find((org) => org.state_id === state.state_id))
          return (
            <Option name="state_id" key={state.state_id} value={state.state_id}>
              {state.state_name}
            </Option>
          );
      });
    }
  };

  const getOrganizationListDetails = () => {
    if (isValidArray(organizationList)) {
      return organizationList.map((org) => {
        if (org.state_id === stateID) {
          return (
            <Option name="org_id" key={org.org_id} value={org.org_id}>
              {org.group_name}
            </Option>
          );
        }
      });
    }
  };

  const selectState = (e) => {
    setGetState(e);
  };

  const getDefaultStateListDetails = () => {
    if (isValidArray(stateList)) {
      return stateList.map((state) => (
        <Option name="state_id" key={state.state_id} value={state.state_id}>
          {state.state_name}
        </Option>
      ));
    }
  };
  const openNewManagerModal = () => {
    setVisible(true);
  };

  function cancel(e) {}

  const columns = [
    {
      title: "Name",
      dataIndex: "first_name",
      key: "first_name",
      width: "25%",
      filters: contractorList
        ?.map((f) => {
          return { text: f.first_name, value: f.first_name };
        })
        .sort((a, b) => a.text.toUpperCase().charCodeAt(0) - b.text.toUpperCase().charCodeAt(0)),
      onFilter: (value, record) => record.first_name.includes(value),
      sorter: (a, b) => handleTableSort(a, b, "first_name"),
    },
    {
      title: "Job Title",
      dataIndex: "job_title",
      key: "job_title",
      width: "25%",
      sorter: (a, b) => handleTableSort(a, b, "job_title"),
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      width: "25%",
      sorter: (a, b) => handleTableSort(a, b, "state"),
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "25%",
      render: (_, elm, row) => (
        <div>
          <span className="mr-3">
            <Tooltip title="View" color="rgb(47, 111, 224)">
              <Button onClick={() => ViewFunction(elm)}>
                <EyeOutlined />
              </Button>
            </Tooltip>
          </span>
          <span className="mr-3">
            <Tooltip title="Edit" color="rgb(47, 111, 224)">
              <Button onClick={() => updateModalFunction(elm)}>
                <EditOutlined />
              </Button>
            </Tooltip>
          </span>
          <span className="mr-3">
            <Popconfirm title="Are you sure to delete this data?" onConfirm={() => deleteFunction(elm)} onCancel={() => cancel} okText="Yes" cancelText="No">
              <Tooltip title="Delete" color="rgb(47, 111, 224)">
                <Button>
                  <DeleteOutlined />
                </Button>
              </Tooltip>
            </Popconfirm>
          </span>
        </div>
      ),
    },
  ];

  return (
    <>
      <Button className="style-btn ml-2" onClick={openNewManagerModal} style={{ float: "right", marginBottom: "20px" }} icon={<PlusCircleOutlined />} shape="round" size="default">
        New Manager
      </Button>
      <Button shape="round" className="ml-2" style={{ float: "right" }} onClick={() => generatePDFManagement(contractorList, columns)} icon={<DownloadOutlined />}>
        PDF
      </Button>
      <Button shape="round" style={{ float: "right" }} onClick={(e) => exportToCSV(excelData(), fileName)} icon={<DownloadOutlined />}>
        Excel
      </Button>
      <Form layout="horizontal">
        <Table
          loading={!isValidArray(contractorList)}
          columns={columns}
          dataSource={contractorList}
          rowKey="id"
          onChange={(pagination, filters, sorter, extra) => {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }}
        />
      </Form>
      <Modal
        title="New Manager"
        centered
        visible={visible}
        footer={null}
        onCancel={() => {
          setVisible(false);
          setStateID("");
        }}
        width={900}
      >
        <Form onFinish={postNewManagerFunction} layout="vertical" form={form2}>
          <Row gutter={[16, 16]} className="justify-content-center ">
            <Col md={10} xs={16}>
              <Form.Item
                name="first_name"
                label="First Name:"
                rules={[
                  {
                    required: true,
                    message: "Please enter the first name.",
                  },
                  {
                    pattern: /^[A-Za-z0-9\s]+$/,
                    message: "Only alphabets and spaces are allowed.",
                  },
                  spaceValidation("First name cannot be empty"),
                ]}
              >
                <Input placeholder="Enter First Name" />
              </Form.Item>
            </Col>
            <Col md={10} xs={16}>
              <Form.Item
                name="last_name"
                label="Last Name:"
                rules={[
                  {
                    required: true,
                    message: "Please enter the last name.",
                  },
                  {
                    pattern: /^[A-Za-z0-9\s]+$/,
                    message: "Only alphabets and spaces are allowed.",
                  },
                  spaceValidation("Last name cannot be empty"),
                ]}
              >
                <Input placeholder="Enter Last Name" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="justify-content-center ">
            <Col md={10} xs={16}>
              <Form.Item
                name="job_title"
                label="Job Title:"
                rules={[
                  {
                    required: true,
                    message: "Please enter the job title.",
                  },
                  {
                    pattern: /^[A-Za-z0-9\s]+$/,
                    message: "Only alphabets and spaces are allowed.",
                  },
                  spaceValidation("Job title cannot be empty"),
                ]}
              >
                <Input placeholder="Enter Job Title" />
              </Form.Item>
            </Col>
            <Col md={10} xs={16}>
              <Form.Item
                name="mobile"
                label="Phone Number:"
                rules={[
                  {
                    pattern: /^[0-9\s]+$/,
                    message: "Only numbers are allowed.",
                  },
                  spaceValidation("Phone number cannot be empty"),
                ]}
              >
                <Input placeholder="Enter Phone number" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="justify-content-center ">
            <Col md={10} xs={16}>
              <Form.Item
                name="email"
                label="Email:"
                rules={[
                  {
                    required: true,
                    message: "Please enter the email.",
                  },
                  { type: "email", message: "Please enter a valid email address." },
                ]}
              >
                <Input placeholder="Enter Email" />
              </Form.Item>
            </Col>
            <Col md={10} xs={16}>
              <Form.Item name="password" label="Password:" extra={PASSWORD_HINT} rules={passwordRules()}>
                <Input.Password placeholder="Enter Password" maxLength={PASSWORD_MAX} />
              </Form.Item>
              <Form.Item name="confirm_password" label="Confirm Password" dependencies={["password"]} rules={confirmPasswordRules("password")}>
                <Input.Password placeholder="Confirm password" maxLength={PASSWORD_MAX} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="justify-content-center ">
            <Col md={10} xs={16}>
              <Form.Item
                name="address"
                label="Address:"
                rules={[spaceValidation("Address cannot be empty")]}
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter the address.",
                //   },
                // ]}
              >
                <Input placeholder="Enter Address" />
              </Form.Item>
            </Col>
            <Col md={10} xs={16}>
              <Form.Item
                name="state_id"
                label="State:"
                rules={[
                  {
                    required: true,
                    message: "Please select the state.",
                  },
                ]}
              >
                <Select onChange={handleStateChange}>{getStateListDetails()}</Select>
              </Form.Item>
            </Col>
            <Col md={10} xs={16}>
              <Form.Item
                name="org_id"
                label="Group:"
                rules={[
                  {
                    required: true,
                    message: "Please select the group.",
                  },
                ]}
               
              >
                <Select  disabled={!stateID}>{getOrganizationListDetails()}</Select>
              </Form.Item>
            </Col>
            <Col md={10} xs={16}></Col>
          </Row>
          <Row gutter={24} className="justify-content-center">
            <Col md={24} style={{ textAlign: "center" }}>
              <Button className="style-btn" htmlType="submit">
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal title="Edit Manager" centered visible={visibleModal} footer={null} onCancel={() => setVisibleModal(false)} width={900}>
        <Form onFinish={updateManagerFunction} layout="vertical" initialValues={defaultValue} form={form}>
          <Row gutter={[16, 16]} className="justify-content-center ">
            <Col md={10} xs={16}>
              <Form.Item
                name="first_name"
                label="First Name:"
                rules={[
                  {
                    required: true,
                    message: "Please enter the first name.",
                  },
                  {
                    pattern: /^[A-Za-z0-9\s]+$/,
                    message: "Only alphabets and spaces are allowed.",
                  },
                  spaceValidation("First name cannot be empty"),
                ]}
              >
                <Input placeholder="Enter First Name" />
              </Form.Item>
            </Col>
            <Col md={10} xs={16}>
              <Form.Item
                name="last_name"
                label="Last Name:"
                rules={[
                  {
                    required: true,
                    message: "Please enter the last name.",
                  },
                  {
                    pattern: /^[A-Za-z0-9\s]+$/,
                    message: "Only alphabets and spaces are allowed.",
                  },
                  spaceValidation("Last name cannot be empty"),
                ]}
              >
                <Input placeholder="Enter Last Name" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="justify-content-center ">
            <Col md={10} xs={16}>
              <Form.Item
                name="job_title"
                label="Job Title:"
                rules={[
                  {
                    required: true,
                    message: "Please enter the job title.",
                  },
                  {
                    pattern: /^[A-Za-z0-9\s]+$/,
                    message: "Only alphabets and spaces are allowed.",
                  },
                  spaceValidation("Job title cannot be empty"),
                ]}
              >
                <Input placeholder="Enter Job Title" />
              </Form.Item>
            </Col>
            <Col md={10} xs={16}>
              <Form.Item
                name="mobile"
                label="Phone Number:"
                rules={[
                  {
                    pattern: /^[0-9\s]+$/,
                    message: "Only numbers are allowed.",
                  },
                  spaceValidation("Phone number cannot be empty"),
                ]}
              >
                <Input placeholder="Enter Phone number" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="justify-content-center ">
            <Col md={10} xs={16}>
              <Form.Item
                name="email"
                label="Email:"
                rules={[
                  {
                    required: true,
                    message: "Please enter the email.",
                  },
                  { type: "email", message: "Please enter a valid email address." },
                ]}
              >
                <Input placeholder="Enter Email" />
              </Form.Item>
            </Col>
            <Col md={10} xs={16}>
              <Form.Item
                name="address"
                label="Address:"
                rules={[spaceValidation("Address cannot be empty")]}
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter the address.",
                //   },
                // ]}
              >
                <Input placeholder="Enter Address" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="justify-content-center ">
            <Col md={10} xs={16}>
              <Form.Item
                name="state"
                label="State:"
                rules={[
                  {
                    required: true,
                    message: "Please select the state.",
                  },
                ]}
              >
                <Select onChange={selectState}>{getDefaultStateListDetails()}</Select>
              </Form.Item>
            </Col>
            <Col md={10} xs={16}>
              {/* <Form.Item
                name="user_id"
                label="User ID:"
                rules={[
                  {
                    required: true,
                    message: "Please enter the user ID.",
                  },
                ]}
              >
                <Input placeholder="Enter User ID" />
              </Form.Item> */}
            </Col>
          </Row>
          <Row gutter={24} className="justify-content-center">
            <Col md={24} style={{ textAlign: "center" }}>
              <Button className="style-btn" htmlType="submit">
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal title="View Manager" centered visible={displayModal} footer={null} onCancel={() => setDisplayModal(false)} width={900}>
        <Form layout="vertical" initialValues={defaultValue} form={form3}>
          <Row gutter={[16, 16]} className="justify-content-center ">
            <Col md={10} xs={16}>
              <Form.Item name="first_name" label="First Name:">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col md={10} xs={16}>
              <Form.Item name="last_name" label="Last Name:">
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="justify-content-center ">
            <Col md={10} xs={16}>
              <Form.Item name="job_title" label="Job Title:">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col md={10} xs={16}>
              <Form.Item name="mobile" label="Phone Number:">
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="justify-content-center ">
            <Col md={10} xs={16}>
              <Form.Item name="email" label="Email:">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col md={10} xs={16}>
              <Form.Item name="address" label="Address:">
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="justify-content-center ">
            <Col md={10} xs={16}>
              <Form.Item name="state" label="State:">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col md={10} xs={16}></Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default memo(ManagementContact);
